/**
 * Forms Settings — the release gate, in ONE place. Plan: docs/plans/2026-10-20-forms-settings-plan.md D19.
 *
 * Area 'formsSettings' in src/utils/followups/uiVersion.js (own key `teamio_forms_settings_ui`, no fallback). At STAGE
 * 'preview' only Super Admins get the new editor; every office keeps today's screens:
 *   gate OFF  the Forms page cog opens the classic Medical History modal (FormsUpdateReminderSettings) and 🔗 opens the
 *             two-tab Procedure Forms editor (switch in its header) — byte for byte;
 *   gate ON   ONE "Settings" button opens the four-tab Forms Settings editor; 🔗 is hidden; Tx Presenter's consent note
 *             says "edit in Forms Settings".
 *
 * Every consumer (FormsHome.vue, SettingsConsent.vue, …) calls formsSettingsUiOn() — never shouldUseNewFollowupsUi
 * directly — so the userKey rule ("every gate call passes the employee ID") is kept in one spot
 * (cypress/node-tests/followups-ui-version.test.js pins that this file is the only reader).
 *
 * NOT one of the three import-free WP0 rule files (formLink.js / newPatient.js / medHx.js): this one imports uiVersion.js.
 */
import { shouldUseNewFollowupsUi, browserStorage } from '@/utils/followups/uiVersion.js';

/**
 * @param {{ isSuperAdmin?: boolean, userKey?: (string|number|null), storage?: object }} [who]
 *   isSuperAdmin  the viewer's role is 'Super Admin' (exactly)
 *   userKey       the employee ID (the office's own "classic Teamio" choice is stored per person)
 * @returns {boolean} true ⇒ draw the Forms Settings editor
 */
export function formsSettingsUiOn({ isSuperAdmin, userKey, storage } = {}) {
  return shouldUseNewFollowupsUi('formsSettings', {
    isSuperAdmin: isSuperAdmin === true,
    storage: storage === undefined ? browserStorage() : storage,
    userKey,
  });
}
